import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import '../../styles/pages/Admin/PromoteUserAdminPage.css';
import useApi from '../../Api';
import { toast } from 'react-toastify';

const PromoteUserAdminPage = () => {
  const [email, setEmail] = useState('');
  const apiClient = useApi();

  const handlePromote = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post('/admin/promote-user', { email });
      toast.success('User promoted to admin successfully.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to promote user.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>WeiFinders Admin Promote User</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="promote-user-admin-div">
        <Card className="promote-user-admin-card">
          <Card.Body>
            <h2 className="promote-user-admin-title">Promote User to Admin</h2>
            <Form onSubmit={handlePromote}>
              <Form.Group controlId="formUserEmail">
                <Form.Label>User Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter user's email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="promote-user-admin-button">
                Promote
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default PromoteUserAdminPage;
